import styled from 'styled-components'

export const NoResultsImage = styled.img`
    width: 20rem;
`